import type { SVGProps } from "react";
export default function SvgDocumentValidationAppNoShadow(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 112 112"
			{...props}
		>
			<foreignObject width={99.4233} height={122} x={-6.73486} y={-5}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1110_698_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_i_1110_698)">
				<path
					fill="url(#paint0_linear_1110_698)"
					fillOpacity={0.6}
					d="M69.288 13H16.666c-2.983 0-5.4 2.408-5.4 5.38v75.24c0 2.972 2.417 5.38 5.4 5.38h52.622c2.983 0 5.4-2.408 5.4-5.38V18.38c0-2.972-2.417-5.38-5.4-5.38"
				/>
				<path
					stroke="url(#paint1_linear_1110_698)"
					d="M16.666 13.5h52.622c2.708 0 4.901 2.187 4.901 4.88v75.24c0 2.693-2.193 4.88-4.901 4.88H16.666c-2.709 0-4.9-2.187-4.9-4.88V18.38c0-2.693 2.191-4.88 4.9-4.88Z"
				/>
			</g>
			<path
				stroke="#FAFF00"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M26.091 85.18q5.454-5.453 5.454-8.726c0-3.272-1.09-3.272-2.181-3.272s-2.217 1.183-2.182 3.272c.037 2.234 1.809 5.32 2.727 6.545 1.636 2.182 2.727 2.727 3.818 1.09l2.182-3.272q.544 4.364 3.272 4.364c.578 0 2.879-2.182 3.272-2.182q.846 0 3.273 2.182"
			/>
			<path
				fill="#FAFF00"
				d="M61.106 40.136H24.808a2.29 2.29 0 0 1-2.294-2.284 2.29 2.29 0 0 1 2.294-2.285h36.298a2.29 2.29 0 0 1 2.294 2.285 2.29 2.29 0 0 1-2.294 2.284"
			/>
			<path
				fill="#FAFF00"
				d="M61.106 54.383H24.808a2.29 2.29 0 0 1-2.294-2.284 2.29 2.29 0 0 1 2.294-2.284h36.298a2.29 2.29 0 0 1 2.294 2.284 2.29 2.29 0 0 1-2.294 2.284"
			/>
			<foreignObject width={102.447} height={83.3584} x={16.7876} y={8.86914}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_1_1110_698_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter1_i_1110_698)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="M93.753 28.567a4.09 4.09 0 1 1 5.784 5.785L61.359 72.53a4.09 4.09 0 0 1-5.785 0L36.486 53.44a4.092 4.092 0 0 1 5.784-5.786l16.196 16.196z"
				/>
				<path
					stroke="url(#paint2_linear_1110_698)"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeOpacity={0.5}
					d="M93.753 28.567a4.09 4.09 0 1 1 5.784 5.785L61.359 72.53a4.09 4.09 0 0 1-5.785 0L36.486 53.44a4.092 4.092 0 0 1 5.784-5.786l16.196 16.196z"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_1110_698"
					x1={43.1386}
					x2={43.1386}
					y1={13}
					y2={99}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1110_698"
					x1={42.9768}
					x2={5.24786}
					y1={13.9418}
					y2={75.7761}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1110_698"
					x1={68.0113}
					x2={68.0113}
					y1={27.3691}
					y2={73.7275}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<clipPath id="bgblur_0_1110_698_clip_path" transform="translate(6.735 5)">
					<path d="M69.288 13H16.666c-2.983 0-5.4 2.408-5.4 5.38v75.24c0 2.972 2.417 5.38 5.4 5.38h52.622c2.983 0 5.4-2.408 5.4-5.38V18.38c0-2.972-2.417-5.38-5.4-5.38" />
				</clipPath>
				<clipPath id="bgblur_1_1110_698_clip_path" transform="translate(-16.788 -8.87)">
					<path d="M93.753 28.567a4.09 4.09 0 1 1 5.784 5.785L61.359 72.53a4.09 4.09 0 0 1-5.785 0L36.486 53.44a4.092 4.092 0 0 1 5.784-5.786l16.196 16.196z" />
				</clipPath>
				<filter
					id="filter0_i_1110_698"
					width={99.4233}
					height={122}
					x={-6.73486}
					y={-5}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_698" />
				</filter>
				<filter
					id="filter1_i_1110_698"
					width={102.447}
					height={83.3584}
					x={16.7876}
					y={8.86914}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_698" />
				</filter>
			</defs>
		</svg>
	);
}
